/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Linkable } from '@/components/blocks/Linkable';
import { breadcrumbTrailContainerSX } from '@/components/content/BreadcrumbTrail/styles/container';
import {
	breadcrumbTextLinkedSX,
	breadcrumbTextSX,
} from '@/components/content/BreadcrumbTrail/styles/typography';
import { useBreadcrumbTrail } from '@/data/Content/BreadcrumbTrail';
import { ContextModal } from '@/data/context/content';
import { ID } from '@/data/types/Basic';
import { Breadcrumbs, Typography } from '@mui/material';
import { FC, useContext, useEffect } from 'react';

export const BreadcrumbTrail: FC<{ id: ID }> = () => {
	const { breadcrumb, uniqueId } = useBreadcrumbTrail();
	const breadcrumbLength = breadcrumb?.length;
	const context = useContext(ContextModal);
	const { onSetBreadCrumbs } = context || {};
	useEffect(() => {
		onSetBreadCrumbs?.(breadcrumb ?? []);
	}, [onSetBreadCrumbs, breadcrumb]);
	return breadcrumbLength ? (
		<Breadcrumbs sx={breadcrumbTrailContainerSX} aria-label={breadcrumb?.at(-1)?.label}>
			{breadcrumb.map(({ href, label }, index: number) => (
				<Linkable
					key={`breadcrumb-${uniqueId}-${index}-${label}`}
					href={index < breadcrumbLength - 1 ? href : undefined}
					type={index < breadcrumbLength - 1 ? 'link' : 'link'}
					data-testid={`breadcrumb-${uniqueId}-${index}-${label}`}
					sx={{ textDecoration: 'none' }}
					id={`breadcrumb-${uniqueId}-${index}-${label}`}
				>
					{index < breadcrumbLength - 1 ? (
						<Typography sx={breadcrumbTextLinkedSX}>{label}</Typography>
					) : (
						<Typography sx={breadcrumbTextSX}>{label}</Typography>
					)}
				</Linkable>
			))}
		</Breadcrumbs>
	) : null;
};
